import { createContext } from 'react';

export const RevokeCertificateContext = createContext();
export const RevokeCertificateDispatchContext = createContext();
